import { ErrorMessage, Field, FieldArray, Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import PageHeader from "../../components/common/PageHeader";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { api,
	isActionPermitted ,
	FIXED_VALUE_INCENTIVE,
	PRECENTAGE_VALUE_INCENTIVE,
	DB_FORMAT,
	APP_UPLOAD_FOLDER_URL,
	BACK_SOCKET_URL,
	USER_TYPES,
	LocalUtils,
	apiWithMultipart
} from "../../util";
import { getSaloonsRequest } from "../../redux/saloons/actions";
import { toast } from "react-toastify";
import Select from 'react-select'
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import "bootstrap";
import axios from "axios";



const UpsertExpense = () => {
  const uploadFolderUrl = BACK_SOCKET_URL + '/api/uploads';
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { permissions } = useSelector((state) => state.user);
  const { saloons } = useSelector((state) => state.saloons);
  const user = useSelector((state) => state.user);
  
  const [periodsOptions, setPeriodsOptions] = useState({});
  const [saloonOptions, setSaloonOptions] = useState({});
  const [periodsDetails, setPeriodsDetails] = useState([]);
  
  const [initialValues, setInitialValues] = useState({
	  selected_period : "",
	  selected_saloon  : "",
	  purpose: "",
	  expense_date : "",
	  amount : "",
	  expense_proof : "",
   });
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
  	  var periodSelection = [];
  	  if (periodsDetails) {
  		periodsDetails.map( (_, index) => {
  			periodSelection.push({ "value": _.id, "label": moment(_.startDate).format('Do MMM YYYY') + " To " + moment(_.endDate).format('Do MMM YYYY')  })
  		})  
  	  }
  	setPeriodsOptions(periodSelection);
  }, [periodsDetails]);
  
  useEffect(() => {
  	  var saloonSelection = [];
  	  if (saloons) {
  		saloons.map( (_, index) => (
  			saloonSelection.push({ "value": _.Saloon.id, "label": _.Saloon.name + " - " + _.Saloon.location })
  	  	 ))  
  	  }
  	setSaloonOptions(saloonSelection); 
  }, [saloons]);
  
  const formatDate = (date, displayDayName = false) => {
      const day = date.getDate();
      const suffix =
        day % 10 === 1 && day !== 11
          ? 'st'
          : day % 10 === 2 && day !== 12
          ? 'nd'
          : day % 10 === 3 && day !== 13
          ? 'rd'
          : 'th';
      
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      return `${day}${suffix} ${month} ${year}`;
    };
  
  useEffect(() => {
    if (isActionPermitted("location", "read", permissions)) {
      
    }
    if (user.role === USER_TYPES.SUPER_ADMIN) {
        dispatch(getSaloonsRequest());
    }
  }, [permissions]);
  
  useEffect(() => {
	  const getPeriodsList = async () => {
    	 setIsLoading(true);
    	 try {
          const response = await api.get("/reports/periods-list" );
          if (response.status === 200) {
        	  //console.log("wwww", response?.data?.data?.list);
        	  setPeriodsDetails(response?.data?.data?.list)
          }
        } catch (error) {
          toast.error(error.response?.data?.message || error.message);
        } finally {
          setIsLoading(false);
        }
      };
      getPeriodsList(id);
  }, []);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
    });
  }, []);
  const onSubmit = async (values) => {
	  
	  if(!values?.selected_period?.value){
		  toast.error("Please select Peiord");
		  return false;
	  }
	  if(user.role === USER_TYPES.SUPER_ADMIN){
		  if(!values?.selected_saloon?.value){
			  toast.error("Please select Saloon");
			  return false;
		  }
	  }
	  
	  setIsLoading(true)
	  const formData = new FormData();
      formData.append('selected_period', values?.selected_period?.value);
      formData.append('purpose', values.purpose);
      formData.append('expense_date', values.expense_date);
      formData.append('amount', values.amount);
      formData.append('expense_proof', file);
      formData.append('expense_proof', file);
      if(user.role === USER_TYPES.SUPER_ADMIN){
    	  formData.append('saloon_id', values?.selected_saloon?.value);
      } else {
    	  formData.append('saloon_id', user?.saloon?.id);
      }
	  
	  if (id === "add") {
	      try {
	    	const response = await apiWithMultipart.post("/expenses", 
	          formData
	        );
	        if (response.status === 201) {
	          toast.success(response?.data?.message || response.message);
	          navigate("/expenses");
	        }
	      } catch (error) {
	        toast.error(error.response?.data?.message || error.message);
	      } finally {
	        setIsLoading(false);
	      }
	    } else {
	      try {
	        const response = await apiWithMultipart.put("/expenses/" + id,formData);
	        if (response.status === 200) {
	          toast.success(response?.data?.message || response.message);
	          navigate("/expenses");
	        }
	      } catch (error) {
	        toast.error(error.response?.data?.message || error.message);
	      } finally {
	        setIsLoading(false);
	      }
	    }
  };
  
  useEffect(() => {
    if (id !== "add") {
      const getExpense = async (id) => {
    	 setIsLoading(true);
    	 try {
          const response = await api.get("/expenses/" + id);
          if (response.status === 200) {
        	 var periodSelectedObject = { 'label' : 'Select' , 'value' : '' };
        	 var salonSelectedObject = { 'label' : 'Select' , 'value' : '' };
        	 if( response?.data?.data?.Period?.id  ){
        		 periodSelectedObject = { 
        				 "value": response?.data?.data?.Period?.id ,
        				 "label": moment(response?.data?.data?.Period?.startDate).format('Do MMM YYYY') + " To " + moment(response?.data?.data?.Period?.endDate).format('Do MMM YYYY') };
        	 }
        	 if( response?.data?.data?.Saloon?.id  ){
        		 salonSelectedObject = { 
        				 "value": response?.data?.data?.Saloon?.id ,
        				 "label":  response?.data?.data?.Saloon?.name + " - " + response?.data?.data?.Saloon?.location };
        	 }
        	 setInitialValues({
              ...response.data.data,
              expense_date: response.data.data.date || "",
              selected_period: periodSelectedObject,
              selected_saloon: salonSelectedObject,
              amount: response.data.data.amount || "",
              purpose: response.data.data.purpose || "",
            });
        	
        	if(response?.data?.data?.proof){
        		setPreview(uploadFolderUrl + '/' + response?.data?.data?.proof );
        	}
        	if (response?.data?.data?.Period?.startDate) {
        		var minDateValue = moment(response.data.data.Period.startDate).format('YYYY-MM-DD')
        		setStartDate(minDateValue);
        	}
        	if (response?.data?.data?.Period?.endDate) {
        		var maxDateValue = moment(response.data.data.Period.endDate).format('YYYY-MM-DD')
        		setEndDate(maxDateValue);
        	}
          }
        } catch (error) {
          toast.error(error.response?.data?.message || error.message);
        } finally {
          setIsLoading(false);
        }
      };
      getExpense(id);
    }
  }, [id]);

  const [startDate , setStartDate] = useState(null);
  const [endDate , setEndDate] = useState(null);
 
  const handlePeriodSelection = (selectedOptions,values, setValues) => {
	  	var selectedDateValue = selectedOptions?.label;
	  	var selectedDateValuesArray = selectedDateValue.split(" To ");
	  	var minDateValue = moment(selectedDateValuesArray[0].replace(/(\d+)(st|nd|rd|th)/, '$1'), 'D MMM YYYY').format('YYYY-MM-DD')
	  	var maxDateValue = moment(selectedDateValuesArray[1].replace(/(\d+)(st|nd|rd|th)/, '$1'), 'D MMM YYYY').format('YYYY-MM-DD')
	  	setStartDate(minDateValue);
	  	setEndDate(maxDateValue);
	  	setValues({ ...values, selected_period: selectedOptions }); 
  }
  
  const handleSaloonelection = (selectedOptions,values, setValues) => {
	  	setValues({ ...values, selected_saloon: selectedOptions }); 
  }
  
  
  const [file, setFile] = useState(null);
  const handleFileSelection = (selectedOptions,values, setValues, file) => {
	  	setFile(file);
  }
  

  const handleNumericField = (e , values , setValues) => {
	var value = e.target.value;
	value = value.replace(/[^\d]/g, "");
	setValues({ ...values , [e.target.name] : value});
  }
  
  const onDateRangeChange = (event , values, setValues ) => {
	  const { name, value } = event.target;
	  setValues({ ...values, expense_date: moment(value).format( "YYYY-MM-DD") });
  };
  const [preview, setPreview] = useState(null);
  
  return (
    <React.Fragment>
      <Formik
        validateOnChange
        initialValues={{ ...initialValues }}
        validationSchema={
          Yup.object().shape({
        	  selected_period: Yup.object().required("Please Select Period"),
        	  selected_saloon: Yup.object().when('$role', {
        		    is: (role) => role === USER_TYPES.SUPER_ADMIN,
        		    then: Yup.object().required('Please Select Saloon'),
        		    otherwise: Yup.object().notRequired()
        	   }),
        	  amount: Yup.string().required("Please Enter Expnse Amount"),
        	  expense_date: Yup.string().required('Please select Expense Date'),
        	  purpose: Yup.string().required("Please Enter Purpose")
        	}) 
        }
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ errors, values, touched, setValues, handleChange, handleBlur, setFieldValue  }) => (
          <>
          	<PageHeader
              shouldShowAddBtn={false}
              title={id === "add" ? "Add Expense" : "Edit Expense"}
            />
            <Card>
              <CardTitle tag="h5" className="border-bottom p-3 mb-0">
                <i className="bi bi-geo-alt-fill me-2"> </i>
                {id === "add" ? "Create a new Expense" : "Edit this Expense"}
              </CardTitle>
              <CardBody>
                <Form>
                  <Row>
                  {user.role === USER_TYPES.SUPER_ADMIN && (
                          <Col xl={6} md={6} sm={6} xs={6}>
                            <FormGroup>
                			<Label for="selected_saloon">Saloon</Label>
                			<Select options={saloonOptions} name="selected_saloon"
                				value={values.selected_saloon}
                				className={ "form-control" + (errors.selected_saloon && touched.selected_saloon ? " is-invalid" : "") }
                			onChange={(e) => {
                				handleSaloonelection(e, values, setValues);
    	                    }}
                			closeMenuOnSelect={true}
                			
                			
                			/>
                			{errors.selected_saloon && touched.selected_saloon && (
               	                 <span component="div" className="invalid-feedback">
               	                    {errors.selected_saloon}
               	                  </span>
               	                )}
                			</FormGroup>
                          </Col>
                        )}
                  <Col xl={user.role === USER_TYPES.SUPER_ADMIN ? 6 : 12} md={user.role === USER_TYPES.SUPER_ADMIN ? 6 : 12} sm={user.role === USER_TYPES.SUPER_ADMIN ? 6 : 12} xs={user.role === USER_TYPES.SUPER_ADMIN ? 6 : 12}>
                  	<FormGroup>
            			<Label for="selected_period">Period Selections</Label>
            			<Select options={periodsOptions} name="selected_period"
            				value={values.selected_period} 
            				className={ "form-control" + (errors.selected_period && touched.selected_period ? " is-invalid" : "") }
            			onChange={(e) => {
            				handlePeriodSelection(e, values, setValues);
	                    }}
            			closeMenuOnSelect={true}
            			
            			
            			/>
            			{errors.selected_period && touched.selected_period && (
           	                 <span component="div" className="invalid-feedback">
           	                    {errors.selected_period}
           	                  </span>
           	                )}
            			</FormGroup>
            		</Col>
	                <Col xl={6}>
		                <FormGroup>
	                    <Label for="expense_date">Expense Date</Label>
	                    
		                <Input
			                name="expense_date"
			                className={ "form-control" + (errors.expense_date && touched.expense_date ? " is-invalid" : "") }
			                onChange={(e) => {
			                	onDateRangeChange(e, values, setValues);
			                }}
		                value={values.expense_date}
			                //value={moment(values.expense_date).format("YYYY-MM-DD")}
		                	max={endDate}
		                	min={startDate}	
			                type="date"
			              />
	                    {errors.expense_date && touched.expense_date && (
	                      <span component="div" className="invalid-feedback">
	                        {errors.expense_date}
	                      </span>
	                    )}
	                  </FormGroup>
	                </Col>
	                <Col xl={6}>
                    <FormGroup>
                      <Label for="name">Amount</Label>
                      <Field id="amount" name="amount" placeholder="Expense Amount" type="text" onChange={(e) => {handleNumericField(e , values , setValues)}}
                        className={ "form-control" + (errors.amount && touched.amount ? " is-invalid" : "") }
                      />
                      {errors.amount && touched.amount && (
                        <span component="div" className="invalid-feedback">
                          {errors.amount}
                        </span>
                      )}
                    </FormGroup>
                </Col>
	                <Col xl={6}>
	                    <FormGroup>
	                      <Label for="name">Purpose</Label>
	                      <Field id="purpose" name="purpose" placeholder="Purpose" type="text"
	                        className={ "form-control" + (errors.purpose && touched.purpose ? " is-invalid" : "") }
	                      />
	                      {errors.purpose && touched.purpose && (
	                        <span component="div" className="invalid-feedback">
	                          {errors.purpose}
	                        </span>
	                      )}
	                    </FormGroup>
	                </Col>
	                <Col xl={6}>
	                    <FormGroup>
	                      <Label for="name">Proof</Label>
	                      <Field id="expense_proof" name="expense_proof" placeholder="Pin Code" type="file"
	                    	  onChange={(event) => {
	                              const file = event.currentTarget.files[0];
	                              if (!file.type.startsWith("image/")) {
	                            	  toast.error("Please select a valid image file (JPG, PNG, GIF, etc.)");
                            	    event.target.value = ""; // reset file input
                            	    return;
                            	  }
	                              handleFileSelection(event, values, setValues, file);
	                              if (file) {
	                                const reader = new FileReader();
	                                reader.onloadend = () => setPreview(reader.result);
	                                reader.readAsDataURL(file);
	                              }
	                            }}
	                        className={ "form-control" + (errors.expense_proof && touched.expense_proof ? " is-invalid" : "") }
	                      />
	                      {errors.expense_proof && touched.expense_proof && (
	                        <span component="div" className="invalid-feedback">
	                          {errors.expense_proof}
	                        </span>
	                      )}
	                      
	                      {preview && (
	                              <div style={{ marginTop: 10 }}>
	                                <img src={preview} alt="Preview" style={{ width: 200 }} />
	                              </div>
	                            )}
	                    </FormGroup>
	                </Col>
             </Row>
             <div className="card-footer border-top-0 d-flex gap-2 mt-4 justify-content-end">
                    <Button
                      color="transaprent"
                      className="border"
                      type="button"
                      onClick={() => navigate("/expenses")}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" disabled={isLoading} className="btn btn-primary">
                      {id === "add" ? "Add Expense" : "Update Expense"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default UpsertExpense;
